import { useLocalSettingsController } from "@/entities/settinglocal"
import { getCurrentLanguage } from "../Helpers"

export function setLanguage(language: string): void {
    const { setSyncSetting } = useLocalSettingsController()
    setSyncSetting("language", language)
}

export function getLanguage(): string | null {
    const { getSyncSetting } = useLocalSettingsController()
    const savedLanguage = getSyncSetting("language")
    if (savedLanguage)
        return savedLanguage
    else
        return getCurrentLanguage()
}
